var exports = {
  "H_": "hovercard__kBFiv4",
  "wx": "header__p8ChRE",
  "h5": "status__GBwqVe",
  "Ie": "visibilitySkeleton__DhB4L3",
  "GT": "visibilityPlaceholder__G0rqvT",
  "vE": "timestamp__D3d68C",
  "DD": "title__3TBGbT",
  "h_": "description__ii1zYW",
  "wO": "descriptionSkeleton__RYMBV8",
  "Gc": "languageSkeleton__EWHN6N",
  "cL": "metaList__2Cc7Mo",
  "KW": "metaRow__86lQiE",
  "t8": "metaIcon___7SFWz",
  "pr": "loadingMetaIcon__FOdn-j",
  "Mt": "metaValue__C9LeZD",
};

module.exports = exports;
